// Packages
import { motion } from "framer-motion";
import convertNumberToPersian from "../../../Utils/convertNumbersToPersian";
import * as Yup from "yup";
// Styles
import Styles from "./Styles/ContactUs.module.css";
// Images
import phoneImage from "../../../Assets/Icons/phone-dark.png";
import emailImage from "../../../Assets/Icons/email-dark.png";
import { useState } from "react";
import { contactUs } from "../../../Services/usersService";
import toast, { Toaster } from "react-hot-toast";

const ContactUs = () => {
  const number = "+98 935 582 0140";

  const ValidationSchema = Yup.object().shape({
    email: Yup.string()
      .required("لطفا ایمیل خود را وارد کنید")
      .email("فرمت ایمیل صحیح نیست"),
    phoneNumber: Yup.string().required("لطفا شماره تماس را وارد کنید"),
    name: Yup.string().required("لطفا نام و نام خانوادگی را وارد کنید"),
    message: Yup.string().required("لطفا پیام خود را بنویسید"),
  });

  const [info, setInfo] = useState({
    email: "",
    phoneNumber: "",
    message: "",
    name: "",
  });

  const handleChange = (e) => {
    setInfo((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await ValidationSchema.validate(info, {
        abortEarly: false,
      });
      const copyInfo = { ...info };
      toast.promise(contactUs(copyInfo), {
        loading: "در حال ارسال پیام شما . . .",
        success: (res) => {
          setInfo({
            email: "",
            phoneNumber: "",
            message: "",
            name: "",
          });
          return res.data.message;
        },
        error: (e) => e.response.data.message,
      });
    } catch (ex) {
      ex.errors.map((i) => toast.error(i));
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      className={Styles.container}
    >
      <Toaster />
      <motion.div
        initial={{ y: -500 }}
        animate={{ y: 0 }}
        transition={{ duration: 1 }}
        className={Styles.contactContainer}
      >
        <h2>تماس با ما</h2>
        <div className={Styles.number}>
          <img src={phoneImage} alt="" />
          <h3>شماره تماس : </h3>
          <h4>{convertNumberToPersian(number)}</h4>
        </div>
        <div className={Styles.email}>
          <img src={emailImage} alt="" />
          <h3>ایمیل اول : horme.operator1@gmail.com</h3>
        </div>
        <div className={Styles.email}>
          <img src={emailImage} alt="" />
          <h3>ایمیل دوم : horme.operator2@gmail.com</h3>
        </div>
      </motion.div>
      <div className={Styles.formContainer}>
        <div className={Styles.forms}>
          <div className={Styles.inputs}>
            <motion.input
              initial={{ x: 800 }}
              animate={{ x: 0 }}
              transition={{ duration: 1 }}
              type="text"
              placeholder="نام و نام خانوادگی"
              value={info.name}
              name="name"
              onChange={handleChange}
            />
            <motion.input
              initial={{ x: 800 }}
              animate={{ x: 0 }}
              transition={{ duration: 1, delay: 0.3 }}
              type="email"
              value={info.email}
              placeholder="ایمیل"
              name="email"
              onChange={handleChange}
            />
            <motion.input
              initial={{ x: 800 }}
              animate={{ x: 0 }}
              transition={{ duration: 1, delay: 0.6 }}
              type="text"
              value={convertNumberToPersian(info.phoneNumber)}
              placeholder="شماره تماس : ۰۹۱۳"
              name="phoneNumber"
              onChange={handleChange}
            />
          </div>
          <motion.textarea
            initial={{ x: -800 }}
            animate={{ x: 0 }}
            transition={{ duration: 1 }}
            className={Styles.messageBox}
            placeholder="پیام شما"
            value={info.message}
            name="message"
            id="contactUsMessage"
            cols="30"
            rows="10"
            onChange={handleChange}
          ></motion.textarea>
        </div>
        <motion.button
          initial={{ y: 100 }}
          animate={{ y: 0 }}
          transition={{ duration: 1 }}
          onClick={handleSubmit}
        >
          ارسال پیام
        </motion.button>
      </div>
    </motion.div>
  );
};

export default ContactUs;
